export default "__VITE_ASSET__oD8PgJuP__"